export const BRAND = {
  name: 'Florida SunKissed Mangoes',
  short: 'Florida SunKissed',
  tagline: 'Tree-Ripened Florida Mangoes Shipped Direct From Local Growers.',
  parentLine: 'A Coastal Capital & AgriCo Company',
  footerTagline: 'From South Florida Growers to Markets Across America.',
  bannerCopy:
    'Limited Seasonal Availability — Florida Mango Season Runs Primarily May Through August',
  contact: {
    email: 'info@coastalcapitalagri.co',
    phone: '+1 844-512-2183',
    phoneHref: 'tel:+18445122183',
    instagram: 'https://www.instagram.com/floridamangoes/',
  },
  logos: {
    primary: '/logos/primary.png',
    mark: '/logos/mark.png',
  },
};

// Real Florida SunKissed Mangoes brand photography (served locally for fast load).
// Originals at /public/media/p*.jpg + video posters at v*-poster.jpg.
export const STOCK = {
  // Big pile of ripe red/orange/yellow mangoes (overhead) — HERO IMPACT
  mangoes_pile: '/media/p1.jpg',
  // Overhead assortment of mangoes in various ripeness — assortment / Box card
  mango_closeup: '/media/p7.jpg',
  // Two ripening mangoes on the branch (green→yellow) — close-up beauty shot
  mango_cut: '/media/p6.jpg',
  // Vibrant overhead pile (wholesale crate feel)
  mango_crate: '/media/p1.jpg',
  // Ripe red mangoes hanging on the tree (golden hour)
  mango_tree: '/media/p5.jpg',
  // Lush fruit-laden orchard in golden hour light
  tropical: '/media/p2.jpg',
  // Assortment of fruit varieties
  variety_array: '/media/p7.jpg',
  // Plated / styled mangoes (used as plated fallback)
  mango_plated: '/media/p6.jpg',
  // Golden hour orchard — perfect for "from grove" sections
  golden_orchard: '/media/p2.jpg',
  // Mango orchard with stepladder — grower / harvest vibe
  grower_hands: '/media/p3.jpg',
  // Green developing mangoes on tree — grove close-up
  mango_grove: '/media/p4.jpg',
  // VIDEO ASSETS (local) + poster frames
  video_hero:  '/media/v1.mp4',
  video_hero_poster: '/media/v1-poster.jpg',
  video_grove: '/media/v2.mp4',
  video_grove_poster: '/media/v2-poster.jpg',
};

export const NAV_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/shop', label: 'Shop Mangoes' },
  { to: '/varieties', label: 'Varieties' },
  { to: '/wholesale', label: 'Wholesale' },
  { to: '/growers', label: 'Growers' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' },
];

export const BOXES = [
  {
    slug: 'small',
    name: 'Small Mango Box',
    price: 75,
    weight: '4–5 lbs',
    count: '6–10 mangoes',
    blurb: 'Perfect for individuals or as a first-time gift. A curated seasonal assortment of hand-selected, tree-ripened Florida mangoes harvested at peak freshness.',
    image: '/media/p6.jpg',
    bestFor: ['First-time buyers', 'Gifts', 'Small households'],
    includes: [
      'Approximately 4–5 lbs of premium Florida mangoes',
      'Hand-selected fruit',
      'Multiple varieties when available',
      'Ripening guide included',
    ],
  },
  {
    slug: 'medium',
    name: 'Medium Mango Box',
    price: 100,
    weight: '7–8 lbs',
    count: '10–16 mangoes',
    blurb: 'Our most popular box — a hand-selected seasonal assortment of tree-ripened Florida mangoes harvested at peak freshness.',
    popular: true,
    image: '/media/p1.jpg',
    bestFor: ['Families', 'Sharing with friends', 'Mango lovers wanting variety'],
    includes: [
      'Approximately 7–8 lbs of premium Florida mangoes',
      'Mixed varieties when available',
      'Harvested fresh from South Florida growers',
      'Ripening guide included',
    ],
  },
  {
    slug: 'large',
    name: 'Large Mango Box',
    price: 150,
    weight: '10–11 lbs',
    count: '15–22 mangoes',
    blurb: 'Maximum mango experience — a generous seasonal assortment of hand-selected, tree-ripened Florida mangoes harvested at peak freshness.',
    image: '/media/p7.jpg',
    bestFor: ['Serious mango enthusiasts', 'Events and gatherings', 'Gifts for clients, family, or friends'],
    includes: [
      'Approximately 10–11 lbs of premium Florida mangoes',
      'Premium hand-selected fruit',
      'Multiple varieties when available',
      'Harvested fresh and shipped with care',
      'Ripening guide included',
    ],
  },
];

export const ADD_ONS = [
  { id: 'extra-2lbs', label: 'Extra 2 lbs of mangoes (+$20)' },
  { id: 'priority-shipping', label: 'Priority shipping' },
  { id: 'gift-message', label: 'Gift message' },
  { id: 'growers-choice', label: "Grower's Choice mixed-variety selection" },
];

export const SEGMENTS = [
  { id: 'restaurants', title: 'Restaurants', blurb: 'Fresh mangoes for menus, desserts, beverages, and specialty dishes.', icon: 'Utensils', image: '/media/p1.jpg' },
  { id: 'grocery', title: 'Grocery Stores', blurb: 'Local Florida-grown fruit for produce departments.', icon: 'ShoppingBasket', image: '/media/p7.jpg' },
  { id: 'fruit-markets', title: 'Fruit Markets', blurb: 'Bulk quantities for roadside stands and produce markets.', icon: 'Store', image: '/media/p1.jpg' },
  { id: 'juice-bars', title: 'Juice Bars & Smoothie Shops', blurb: 'Consistent seasonal supply for beverages and fresh fruit products.', icon: 'GlassWater', image: '/media/p6.jpg' },
  { id: 'hotels', title: 'Hotels & Resorts', blurb: 'Premium fruit for guests, events, and hospitality programs.', icon: 'Hotel', image: '/media/p5.jpg' },
  { id: 'events', title: 'Event Vendors', blurb: 'Mango festivals, farmers markets, and special events.', icon: 'PartyPopper', image: '/media/p7.jpg' },
  { id: 'distributors', title: 'Produce Distributors', blurb: 'Bulk seasonal mango supply for regional and national distribution.', icon: 'Truck', image: '/media/p2.jpg' },
];

export const TIERS = [
  { name: 'Starter Wholesale', qty: '50+ mangoes', desc: 'Local restaurants & juice bars.' },
  { name: 'Small Wholesale', qty: '100+ mangoes', desc: 'Small grocers & fruit markets.' },
  { name: 'Medium Wholesale', qty: '250+ mangoes', desc: 'Multi-location restaurants & retailers.' },
  { name: 'Large Wholesale', qty: '500+ mangoes', desc: 'Regional retailers & event programs.' },
  { name: 'Commercial / Distributor', qty: '1,000+ mangoes', desc: 'Produce distributors & food service.' },
  { name: 'Truckload Program', qty: '5,000+ / Custom', desc: 'Out-of-state bulk distribution.' },
];

export const PROCESS_STEPS = [
  { step: 1, title: 'Submit a Wholesale Inquiry', body: 'Tell us your target quantity, varieties, and delivery timeline.' },
  { step: 2, title: 'Inventory & Availability Review', body: 'We review current harvest schedules and available inventory across our grower network.' },
  { step: 3, title: 'Custom Quote', body: 'Receive pricing, availability, logistics options, and delivery estimates.' },
  { step: 4, title: 'Fulfillment & Distribution', body: 'Fruit is harvested, packed, and coordinated for pickup, delivery, or freight shipment.' },
];

export const SERVICE_AREAS = [
  { name: 'Local', desc: 'Palm Beach County pickup and same-region delivery.', icon: 'MapPin' },
  { name: 'Regional', desc: 'South Florida & statewide Florida delivery.', icon: 'Map' },
  { name: 'National', desc: 'Bulk orders and distribution partnerships throughout the United States.', icon: 'Truck' },
];

export const WHY_US = [
  'Direct grower relationships',
  'Florida-grown fruit',
  'Seasonal variety selection',
  'Wholesale quantities available',
  'Distribution support',
  'Local and regional delivery options',
  'Out-of-state bulk order coordination',
  'Reliable communication and scheduling',
];

export const FAQ_ITEMS = [
  { q: 'What is your minimum wholesale order?', a: 'Typically 50+ mangoes for local wholesale; distributor and truckload programs have separate minimums.' },
  { q: 'Do you offer mixed varieties?', a: 'Yes — mixed seasonal varieties are available based on current harvests and grower availability.' },
  { q: 'Can I reserve fruit in advance?', a: 'Yes. Advance reservations are encouraged, especially during peak season (June – August).' },
  { q: 'Do you deliver?', a: 'Yes — local delivery is available throughout South Florida for qualifying orders; regional and national logistics can be coordinated.' },
  { q: 'Are all mangoes Florida-grown?', a: 'Yes. Every mango we source is grown in Florida — primarily Palm Beach, Broward, and Miami-Dade counties.' },
  { q: 'Do you work with recurring buyers?', a: 'Yes. We welcome long-term wholesale and distribution partnerships across the season.' },
];

// Seasonal calendar data (each variety + months it’s in season)
export const SEASON_CALENDAR = [
  { variety: 'Haden',          months: [4, 5, 6] },        // May, Jun, Jul
  { variety: 'Carrie',         months: [5, 6] },           // Jun, Jul
  { variety: 'Tommy Atkins',   months: [5, 6, 7] },        // Jun, Jul, Aug
  { variety: 'Kent',           months: [6, 7, 8] },        // Jul, Aug, Sep
  { variety: 'Valencia Pride', months: [6, 7, 8] },        // Jul, Aug, Sep
  { variety: 'Keitt',          months: [7, 8, 9] },        // Aug, Sep, Oct
  { variety: "Grower's Choice Mix", months: [4, 5, 6, 7, 8, 9] },
];

export const MONTH_LABELS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// Full list of possible mango varieties across our seasonal harvests.
export const POSSIBLE_VARIETIES = [
  'Kent', 'Haden', 'Valencia Pride', 'Dwarf Hawaiian', 'Butter Blush',
  'Turpentine', 'Peach', 'Bailey\'s Marvel', 'Haitian', 'Duncan',
];

// Local delivery pricing (South Florida Tri-County + WPB free zone)
export const DELIVERY_COUNTIES = [
  { id: 'wpb', label: 'West Palm Beach', fee: 0, note: 'FREE Delivery' },
  { id: 'palm-beach', label: 'Palm Beach County', fee: 15, note: '$15 Delivery Fee' },
  { id: 'broward', label: 'Broward County', fee: 25, note: '$25 Delivery Fee' },
  { id: 'miami-dade', label: 'Miami-Dade County', fee: 35, note: '$35 Delivery Fee' },
];

// Free local delivery threshold + minimum order weight
export const LOCAL_DELIVERY = {
  freeThreshold: 200,        // orders $200+ ship free locally
  minWeightLbs: 10,          // 10 lb minimum for all local delivery
  pricePerLb: 6.00,          // starting rate for pickup + delivery
};

// States we cannot ship to due to agricultural regulations
export const NO_SHIP_STATES = ['CA', 'HI'];
